export enum MeridianEnum {
  AM = 'AM',
  PM = 'PM',
}

export enum MoodEnum {
  HAPPY = 'Happy',
  SAD = 'Unhappy',
  NOT_SURE = 'Average',
}
